module.exports = __webpack_public_path__ + "static/img/award2_a.0dd666b.png";


//////////////////
// WEBPACK FOOTER
// ./static/hk/img/index/award2_a.png
// module id = W4/w
// module chunks = 7